export class GuidService {
  static DEFAULT_EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

  static parseEmptyGuid(guid: string): any {
    if (!guid) {
      return null;
    }
    if (guid === this.DEFAULT_EMPTY_GUID) {
      return null;
    }
    return guid;
  }

  static parseEmptyGuids(guids: string[]): any {
    if (guids === null || guids.length === 0) {
      return null;
    }
    return guids.filter((x) => x !== this.DEFAULT_EMPTY_GUID);
  }

  static isEmptyGuid(guid: string): boolean {
    if (!guid) {
      return false;
    }
    return guid === this.DEFAULT_EMPTY_GUID;
  }
}
